import ApiService from '../../components/api_services/apiService.jsx';
import ActionMenu from '../../components/components/action_menu/ActionMenu.jsx';

import { ReactComponent as StatusUp } from '../../components/icons/status-up.svg';
import { ReactComponent as Edit } from '../../components/icons/edit.svg';
import { ReactComponent as TaskSquare } from '../../components/icons/task-square.svg';
import { ReactComponent as Pause } from '../../components/icons/pause.svg';
import { ReactComponent as Play } from '../../components/icons/play.svg';
import { ReactComponent as Trash } from '../../components/icons/trash.svg';

import {
  toggleCheckedItem,
  toggleEditModal,
  toggleAddModal,
  setEditedEvent,
  setAddEventMode,
  setDuplicatedEventId,
  setModalViewActualTab,
  toggleNeedRefresh,
  setEditModalMode,
  setVisibleEventIds,
  setTotalElements,
} from '../../store/eventsSlice';
import { setSelectedEvent, toggleActiveTab } from '../../store/statsSlice.js';
import {
  getEventStatusLabel,
  getEventStatusClassName,
} from './eventStatus.js';

const formatDate = (utcString) => {
  if (!utcString) {
    return '-';
  }

  const date = new Date(utcString);
  if (Number.isNaN(date.getTime())) {
    return '-';
  }

  return date.toLocaleString('pl-PL', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const fetchUsers = async (
  sortBy,
  sortDirection,
  currentPage,
  dispatch,
  setMaxPages,
  setRows,
  checkedItems,
  keyword,
  filterQuery,
  onDeleteEvent,
  editedEvent,
  editModalOpen,
  pageSize = 10,
  navigate = null
) => {
  try {
    const checkedSortBy = sortBy === null || sortDirection === null ? null : sortBy;
    const checkedSortDirection = sortBy === null || sortDirection === null ? null : sortDirection;
    const responseCategories = await ApiService.getEventsCategories();
    const categories = responseCategories.data;
    const response = await ApiService.getEvents(checkedSortBy, checkedSortDirection, currentPage, keyword, filterQuery, pageSize);
    console.log('Odpowiedź z API:', response);

    dispatch(setMaxPages(response.maxPage));
    if (response.totalElements !== undefined) {
      dispatch(setTotalElements(response.totalElements));
    }
    dispatch(setVisibleEventIds(response.data.map((event) => event.id)));

    const openEditMode = (eventId) => {
      dispatch(setAddEventMode(false));
      dispatch(setModalViewActualTab('Dane podstawowe'));
      dispatch(setEditModalMode('edit'));
      dispatch(setEditedEvent(eventId));
      dispatch(toggleEditModal());
    };

    const openPreviewMode = (eventId) => {
      dispatch(setAddEventMode(false));
      dispatch(setModalViewActualTab('Dane podstawowe'));
      dispatch(setEditModalMode('preview'));
      dispatch(setEditedEvent(eventId));
      dispatch(toggleEditModal());
    };

    const previewCell = (content, eventId) => (
      <div
        className={`events-preview-trigger ${editModalOpen && editedEvent === eventId ? 'events-preview-trigger-active' : ''}`}
        role="button"
        tabIndex={0}
        onClick={() => openPreviewMode(eventId)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            openPreviewMode(eventId);
          }
        }}
      >
        {content}
      </div>
    );

    const mappedRows = response.data.map((event) => {
      const isActiveRow = editModalOpen && editedEvent === event.id;

      return {
        rowClass: isActiveRow ? 'events-row-active' : '',
        columns: [
          <input
            type="checkbox"
            checked={checkedItems && checkedItems.includes(event.id)}
            onChange={() => dispatch(toggleCheckedItem(event.id))}
          />,
          event.id,
          <div>
            <ActionMenu
              items={[
                {
                  key: 'stats',
                  label: 'Statystyki',
                  icon: StatusUp,
                  onClick: () => {
                    dispatch(setSelectedEvent(Number(event.id)));
                    dispatch(toggleActiveTab('Ogólne'));
                    if (navigate) {
                      navigate('/statistics');
                    } else {
                      window.location.href = '/statistics';
                    }
                  },
                },
                {
                  key: 'edit',
                  label: 'Edytuj',
                  icon: Edit,
                  disabled: event.hasPendingEdit === true,
                  onClick: () => openEditMode(event.id),
                },
                {
                  key: 'preview',
                  label: 'Podgląd',
                  icon: Edit,
                  onClick: () => openPreviewMode(event.id),
                },
                {
                  key: 'duplicate',
                  label: 'Duplikuj',
                  icon: TaskSquare,
                  onClick: () => {
                    dispatch(setAddEventMode(true));
                    dispatch(setModalViewActualTab('Dane podstawowe'));
                    dispatch(setEditedEvent(null));
                    dispatch(setDuplicatedEventId(event.id));
                    dispatch(toggleAddModal());
                  },
                },
                {
                  key: 'deactivate',
                  label: event.isActive ? 'Dezaktywuj' : 'Aktywuj',
                  icon: event.isActive ? Pause : Play,
                  disabled: event.hasPendingEdit === true || (event.isApprovedByAdmin === false && event.isRejectedByAdmin !== true),
                  onClick: async () => {
                    try {
                      await ApiService.updateEvent(event.id, { isActive: !event.isActive });
                      dispatch(toggleNeedRefresh());
                    } catch (error) {
                      console.error('Błąd zmiany statusu wydarzenia:', error);
                    }
                  },
                },
                {
                  key: 'delete',
                  label: 'Usuń',
                  icon: Trash,
                  danger: true,
                  onClick: () => onDeleteEvent(event.id),
                },
              ]}
            />
          </div>,
          previewCell(formatDate(event.added_on_utc), event.id),
          previewCell(event.name, event.id),
          previewCell(<div>{event.city} - {event.place}</div>, event.id),
          previewCell(formatDate(event.startDate), event.id),
          previewCell(formatDate(event.endDate), event.id),
          previewCell(categories.find((cat) => cat.id === event.categoryId)?.name || 'Brak kategorii', event.id),
          previewCell(<span className={getEventStatusClassName(event)}>{getEventStatusLabel(event)}</span>, event.id),
        ],
      };
    });

    setRows(mappedRows);
  } catch (error) {
    console.error('Błąd podczas pobierania danych:', error);
  }
};
